import React from 'react';

const s = {
  bar: {
    background: 'rgba(1,51,105,0.25)',
    borderBottom: '1px solid rgba(1,51,105,0.4)',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap'
  },
  label: { fontSize: 12, color: '#7fb3ff', fontWeight: 700, letterSpacing: 0.5 },
  select: {
    padding: '7px 14px',
    background: 'rgba(0,0,0,0.4)',
    border: '1px solid rgba(1,51,105,0.6)',
    borderRadius: 8,
    color: '#fff',
    fontSize: 14,
    fontWeight: 600,
    outline: 'none',
    cursor: 'pointer',
    minWidth: 200
  },
  badge: {
    fontSize: 12,
    color: '#7fb3ff',
    background: 'rgba(1,51,105,0.3)',
    padding: '4px 10px',
    borderRadius: 10
  },
  manageBtn: {
    padding: '6px 14px',
    borderRadius: 7,
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.1)',
    color: '#778',
    cursor: 'pointer',
    fontSize: 12,
    fontWeight: 600,
    marginLeft: 'auto'
  }
};

export default function PoolSelector({ pools, selectedPool, onSelect, onManage }) {
  if (!pools || pools.length === 0) return (
    <div style={s.bar}>
      <span style={{ ...s.label, color: '#556' }}>No pools yet</span>
      <button style={{ ...s.manageBtn, color: '#7fb3ff', borderColor: 'rgba(127,179,255,0.3)', background: 'rgba(127,179,255,0.08)' }} onClick={onManage}>
        🏆 Create or Join a Pool
      </button>
    </div>
  );

  return (
    <div style={s.bar}>
      <span style={s.label}>🏆 POOL</span>
      <select
        style={s.select}
        value={selectedPool?.id || ''}
        onChange={e => {
          const pool = pools.find(p => p.id === parseInt(e.target.value));
          onSelect(pool || null);
        }}
      >
        {pools.map(p => (
          <option key={p.id} value={p.id}>
            {p.name} ({p.member_count} member{p.member_count !== 1 ? 's' : ''})
            {p.isCommissioner ? ' ⭐' : ''}
          </option>
        ))}
      </select>
      {selectedPool && (
        <span style={s.badge}>
          Invite: <strong style={{ letterSpacing: 2 }}>{selectedPool.invite_code}</strong>
        </span>
      )}
      <button style={s.manageBtn} onClick={onManage}>Manage Pools</button>
    </div>
  );
}
